/* eslint-disable no-shadow */
import React, { createContext, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { useNavigate } from 'react-router-dom';
// utils
import * as authAPI from 'api/auth';

import { setLogout } from '../redux/slice/global';
import axios from '../utils/axios';
import { isValidToken, setSession } from '../utils/jwt';

import { initStaffAction, restStaffAction } from '../redux/slice/staff';

import { useDispatch } from '../redux/store';

// ----------------------------------------------------------------------

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
  merchantId: '',
};

const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, user } = action.payload;
    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user,
    };
  },
  LOGIN: (state, action) => {
    const { user } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },
  LOGOUT: (state) => ({
    ...state,
    isAuthenticated: false,
  }),
  REGISTER: (state, action) => {
    const { user } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },
  GETPROFILE: (state, action) => {
    const { user } = action.payload;
    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },
  SET_MERCHANT_ID: (state, action) => {
    // eslint-disable-next-line camelcase
    const { merchant_id } = action.payload;
    return {
      ...state,
      merchantId: merchant_id,
    };
  },
};

const reducer = (state, action) =>
  handlers[action.type] ? handlers[action.type](state, action) : state;

const AuthContext = createContext({
  ...initialState,
  method: 'jwt',
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  register: () => Promise.resolve(),
  getProfile: () => Promise.resolve(),
});

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const dispatchRedux = useDispatch();
  const navigate = useNavigate();

  const { isLogout } = useSelector((state) => state.global);

  useEffect(() => {
    const initialize = async () => {
      try {
        const accessToken = window.localStorage.getItem('accessToken');
        if (accessToken && isValidToken(accessToken)) {
          setSession(accessToken);
          const response = await authAPI.getUserProfile(accessToken);
          const user = response;
          dispatchRedux(initStaffAction(user.staff[0]));

          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: true,
              user,
            },
          });
        } else {
          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: false,
              user: null,
            },
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null,
          },
        });
      }
    };

    initialize();
  }, []);

  useEffect(() => {
    if (isLogout) {
      dispatch({ type: 'LOGOUT' });
    }
    return () => {
      dispatchRedux(setLogout(false));
    };
  }, [isLogout]);

  const login = async (username, password) => {
    const response = await authAPI.login({
      username,
      password,
    });
    if (response.result && response.result === 200) {
      return response;
    }
    setSession(response);
    return response;
  };
  const getProfile = async (accessToken) => {
    const response = await authAPI.getUserProfile(accessToken);
    dispatchRedux(initStaffAction(response.staff[0]));

    // eslint-disable-next-line no-debugger
    dispatch({
      type: 'GETPROFILE',
      payload: {
        isAuthenticated: true,
        user: response,
      },
    });
    return response;
  };

  const register = async (email, password, firstName, lastName) => {
    const response = await axios.post('/api/account/register', {
      email,
      password,
      firstName,
      lastName,
    });
    const { accessToken, user } = response.data;

    window.localStorage.setItem('accessToken', accessToken);
    dispatch({
      type: 'REGISTER',
      payload: {
        user,
      },
    });
  };
  // 登出系統
  const logout = async () => {
    await authAPI.logout();
    setSession(null);
    localStorage.removeItem('merchant_id');
    dispatch({ type: 'LOGOUT' });
    dispatchRedux(restStaffAction());
    navigate('/');
  };

  // 不調用接口，直接登出
  const forceLogout = async () => {
    dispatch({ type: 'LOGOUT' });
  };

  const setMerchantId = async (merchantId) => {
    dispatch({ type: 'SET_MERCHANT_ID', payload: { merchantId } });
  };
  const resetPassword = () => {}; // 沒有用到

  const updateProfile = async () => {
    try {
      const accessToken = window.localStorage.getItem('accessToken');

      if (accessToken) {
        const response = await authAPI.getUserProfile(accessToken);
        const { user } = response.data;

        dispatchRedux(initStaffAction(user.staff[0]));

        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: true,
            user,
          },
        });
      } else {
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null,
          },
        });
      }
    } catch (err) {
      dispatch({
        type: 'INITIALIZE',
        payload: {
          isAuthenticated: false,
          user: null,
        },
      });
    }
  };
  return (
    <AuthContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        ...state,
        method: 'jwt',
        login,
        logout,
        register,
        resetPassword,
        updateProfile,
        getProfile,
        forceLogout,
        setMerchantId,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
AuthProvider.propTypes = {
  children: PropTypes.node,
};
AuthProvider.defaultProps = {
  children: '',
};
export { AuthContext, AuthProvider };
